import styled, { css } from 'styled-components';
import { MEDIUM } from '../utils/styled';
export const Input = styled.input `
    background-color: rgba(53, 54, 49, 0.55);
    box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.3), inset 0px 2px 6px rgba(39, 39, 39, 0.4);
    border: none;
    border-radius: 12px;
    box-sizing: border-box;
    color: #EDEDF2;
    display: block;
    font-family: inherit;
    font-size: 1rem;
    height: 54px;
    line-height: 1;
    outline: none;
    padding: 0.75rem;
    width: 100%;
    font-weight: ${MEDIUM};
    font-size: 1rem;
    line-height: 1.25rem;
    letter-spacing: 0px;

    /* Avoids weird browser bug where translucent elements with
     * same background colour and same opacity render with
     * different colours
     */
    backface-visibility: hidden;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: #efefef;
        border-color: #efefef;
        color: #32323280;
    }

    &:not(:disabled):focus {
        border: 1px solid #efefef;
        box-shadow: none;
        outline: none;
    }

    &::placeholder {
        color: rgba(235, 235, 245, 0.6);
    }

    /* Date picker icon on Chrome is an image, so we can't style it but we can use filter to make it white */
    &::-webkit-calendar-picker-indicator {
        filter: invert(60%);
    }
    &::-webkit-calendar-picker-indicator:hover {
        filter: invert(90%);
    }

    &[type='number'] {
        appearance: textfield; /* Hide spin buttons for Mozilla based browsers */
        display: inline-block;
        margin: 0;
        width: 100%;
    }

    /* Hide spin buttons for Webkit based browsers */
    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        appearance: none;
        margin: 0;
    }

    ${({ $invalid }) => !!$invalid &&
    css `
            &:not(:disabled),
            &:not(:disabled):focus {
                border-color: #ff5c00;
            }
        `}
`;
